import React, {useEffect, useState} from 'react';
import { Button, Form, TextArea, Input, Label, Icon } from "semantic-ui-react";
import { Controller, useForm, SubmitHandler } from "react-hook-form";
import styles from './SendEmailForm.module.scss'
//import {IClient} from "../../../../store/cms/clients/types";
//import {createClient, editClient} from "../../../../store/cms/clients/cmsClientsSlice";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import { sendEmail } from './Shared.slice';
//import Permissions from "../../../../components/Permissions/Permissions";
//import {readClientPermissions} from "../../../../store/cms/permissions/permissionsSlice";
import { IEmail } from '../../shared/interfaces/IEmail';

const SendEmailForm: React.FC = () => {
    const dispatch = useAppDispatch()
    const { control, handleSubmit, formState: { errors }, getValues, setValue } = useForm<IEmail>();
    const [data, setFormData] = useState<IEmail>({ name: '', email: '', subject: '', body: '' });

    useEffect(() => {
        setValue("name", data.name)
        setValue("email", data.email)
        setValue("subject", data.subject)
        setValue("body", data.body)
    }, [data, setValue]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...data, [e.target.name]: e.target.value });
    };

    const onSubmit = (data: IEmail) => {
        const payload: IEmail = {
            name: getValues("name"),
            email: getValues("email"),
            subject: getValues("subject"),
            body: getValues("body")
        }
        dispatch(sendEmail(payload));
        window.history.back();
    };
    return (
        <div className="form-overlay-general">
            <Form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                <Icon color="red" name="close" size="large" style={{ float: "right", cursor: "pointer" }} onClick={() => window.history.back()}/>
                <div className={styles.formRow}>
                    <Form.Field className={styles.formField}>
                        <Label>Name</Label>
                        <Controller name="name" control={control} rules={{required: true}}
                            render={({ field }) => (
                                <div className={styles.inputInner}>
                                    <Input placeholder={"Enter name"} {...field} />
                                </div>
                            )}
                        />
                    </Form.Field>
                    <Form.Field className={styles.formField}>
                        <Label>Email</Label>
                        <Controller name="email" control={control} rules={{required: true, pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/}}
                            render={({ field }) => (
                                <div className={styles.inputInner}>
                                    <Input placeholder={"Enter email"} {...field} />
                                </div>
                            )}
                        />
                        {errors.email && errors.email.type === 'required' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>The email field is required</p>
                            </div>}
                        {errors.email && errors.email.type === 'pattern' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>Email should be like example@xxx.xx</p>
                            </div>
                        }
                    </Form.Field>
                </div>
                <Form.Field>
                    <Label>Subject</Label>
                    <Controller name="subject" control={control} rules={{required: true}}
                        render={({ field }) => (
                            <div className={styles.inputInner}>
                                <Input placeholder={"Enter subject"} {...field} />
                            </div>
                        )}
                    />
                </Form.Field>
                <Form.Field>
                    <Label>Body</Label>
                    <Controller name="body" control={control} rules={{required: true}}
                        render={({ field }) => (
                            <div className={styles.inputInner}>
                                <TextArea placeholder={"Enter body"} {...field} />
                            </div>
                        )}
                    />
                    {errors.body && errors.body.type === 'required' &&
                        <div className={'darts-users-form-error-wrap'}>
                            <div><i className="warning sign red icon"></i></div>
                            <p className='darts-users-form-error'>The body field is required</p>
                        </div>
                    }
                </Form.Field>
                <Button id="send_email" color='teal' type="submit" onClick={(e) => handleSubmit(onSubmit)(e)}>Send Email</Button>
            </Form>
        </div>
    );
};

export default SendEmailForm;

/** AI generated code for a contact form component in React
import React, { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const response = await fetch('https://your-backend-api.com/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setStatus('��������� ����������!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('������ ��� ��������.');
      }
    } catch (error) {
      setStatus('������� ������.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="���" required />
      <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" required />
      <textarea name="message" value={formData.message} onChange={handleChange} placeholder="���������" required />
      <button type="submit">���������</button>
      <p>{status}</p>
    </form>
  );
}
 */